import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { Download, Upload } from "lucide-react";
import api, { formatApiError } from "../lib/api";

export default function ImportPage() {
  const { stores, storeId, isMaster } = useOutletContext();
  const effStore = storeId !== "all" ? storeId : stores[0]?.id;
  const [risOrdini, setRisOrdini] = useState(null);
  const [risAdv, setRisAdv] = useState(null);

  const downloadTemplate = async (tipo) => {
    const res = await api.get(`/import/template/${tipo}`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `template_${tipo}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const upload = async (tipo, file) => {
    const fd = new FormData();
    fd.append("file", file);
    try {
      const res = await api.post(`/import/${tipo}?store_id=${effStore}`, fd);
      if (tipo === "ordini") setRisOrdini(res.data); else setRisAdv(res.data);
      toast.success("Import completato");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const Zone = ({ tipo, ris, testid }) => (
    <div className="bg-white border border-slate-200 rounded-lg p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-slate-800">Import {tipo === "ordini" ? "ordini" : "spesa ADV"}</h2>
        <button data-testid={`csv-download-template-${tipo}`} onClick={() => downloadTemplate(tipo)}
          className="flex items-center gap-1.5 border border-slate-300 text-slate-700 text-sm rounded-md px-3 py-1.5 hover:bg-slate-50">
          <Download className="w-4 h-4" /> Scarica template CSV
        </button>
      </div>
      <label data-testid={`csv-upload-dropzone-${tipo}`}
        className="block border-2 border-dashed border-slate-300 hover:border-indigo-500 bg-slate-50/50 rounded-xl p-8 text-center cursor-pointer transition-colors">
        <Upload className="w-6 h-6 mx-auto text-slate-400 mb-2" />
        <span className="text-sm text-slate-500">Clicca per scegliere il file CSV (separatore ; o ,, decimali con virgola)</span>
        <input type="file" accept=".csv,text/csv" className="hidden" data-testid={testid}
          onChange={(e) => e.target.files[0] && upload(tipo, e.target.files[0])} />
      </label>
      {ris && (
        <div data-testid={`csv-risultato-${tipo}`} className="text-sm bg-slate-50 border border-slate-200 rounded-md p-3 font-mono">
          {"inseriti" in ris && <div>Inseriti: <b>{ris.inseriti}</b></div>}
          {"saltati_duplicati" in ris && <div>Saltati (duplicati): <b>{ris.saltati_duplicati}</b></div>}
          {"ignorati_pre_data_inizio" in ris && <div>Ignorati (prima della data inizio dati): <b>{ris.ignorati_pre_data_inizio}</b></div>}
          {ris.errori?.length > 0 && (
            <div className="text-red-600 mt-1">Errori: {ris.errori.map((e) => `riga ${e.riga}: ${e.motivo}`).join(" · ")}</div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <div data-testid="import-page" className="space-y-6 max-w-4xl">
      <div className="flex items-center gap-3">
        <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Import CSV</h1>
        <span className="text-sm text-slate-500">Store di destinazione: <b>{stores.find((s) => s.id === effStore)?.nome}</b></span>
      </div>
      {!isMaster && <p className="text-xs text-slate-500">Come socio puoi importare solo nel tuo store.</p>}
      <Zone tipo="ordini" ris={risOrdini} testid="csv-file-ordini" />
      <Zone tipo="adv" ris={risAdv} testid="csv-file-adv" />
    </div>
  );
}
